import { FC } from 'react';

import CustomMovementsSectionHeader from './components/CustomMovementsSectionHeader';
import CustomMovementsSectionBody from './components/CustomMovementsSectionBody';

const CustomMovementsSection: FC = () => (
  <div className="mb-5">
    <CustomMovementsSectionHeader />
    <CustomMovementsSectionBody />
  </div>
);

export default CustomMovementsSection;
